import { HttpContextToken } from '@angular/common/http';

// Маршруты, где 403 — штатный отказ по роли или заморозке демо, а не след смены identity: сверять
// владельца с сервером на каждый такой ответ значит обнулять кэш сессии там, где ничего не менялось.
export const EXPECTED_FORBIDDEN = new HttpContextToken<boolean>(() => false);
